export default __webpack_public_path__ + "static/media/download.1d972cb9.png";